import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class ActivityController 
{
    async create(data) {
        const response = await api.activity().post(data);
        return apiCallbackTreatment(response);
    }

    async deleteById(id)
    {
        const response = await api.activity().remove(id);
        return apiCallbackTreatment(response);
    }

    async get() 
    {
        const response = await api.activity().get();
        return apiCallbackTreatment(response);
    }

    async getByBusiness(id) 
    {
        const response = await api.activity().getByBusiness(id);
        return apiCallbackTreatment(response);
    }

    async update(id, data) {
        const response = await api.activity().update(id, data);
        return apiCallbackTreatment(response);
    }
}